import { Subject } from 'rxjs/internal/Subject';
/**
 * Class used to Configure DatePicker Properies.
 */
export class FnDateConfig {
	/**
	 * Mindate to show in DatePicker.
	 */
	minDate: Date = new Date('1-1-1990');
	/**
	 * Maxdate to show in DatePicker
	 */
	maxDate: Date = null;
	/**
	 * Navigation
	 */
	navigation = 'select';
	/**
	 * starting Day to show on datePicker
	 * Default value is 2 (Monday)
	 */
	startingDay = 2;
	/**
	 * No of Months to display on DatePicker Calender
	 */
	displayMonths = 1;
	/**
	 * handle next prev functionality
	 */
	isAutoHandler = false; // handle next prev functionality
	/**
	 * use this if you are using the autoHandler.
	 */
	isFutureDisable = false;
	/**
	 * No of days to add or subtract when click on next or Prev button and isAutoHandler is true.
	 */
	noOfNavDay = 7;
	/**
	 * disabledDate used to compare date to disable date and next button if isAutoHandler and isFutureDisabled is true.
	 */
	disabledDate: Date = new Date();

	/**
	 * if true then show month only.
	 */
	isMonthView = false;
	/**
	 * used to show month view on datePicker
	 */
	type:string = null;
	/**
	 * angular subect method used to update date picker view based on weekly,monthly selected option
	 */
	datePickerAction: Subject<FnDateConfig> = new Subject();
	/**
	 * used to update the format of date based on weekly,monthly selected option
	 */
	format = 'd/M/Y';
}

export interface FNDateRangeModel {
	startDate: Date;
	endDate: Date;
}
